import { Button, FormControl, Grid, TextField, Typography } from '@mui/material'
import React from 'react'
import { ArrowLeftCircle, ArrowRightCircle } from 'react-feather'

export const FormDebtSummary = ({ useFetchInit }) => {

  const {
    //------------- Generales
    defaultData,
    //------------- globalStates
    globalStates,
    //------------- Helpers
    Helpers,
    //------------- Formularios
    Forms,
    //------------- FetchData
    FetchData,
    //------------- Actions
    Actions
  } = useFetchInit

  const { stepApplilication } = globalStates

  const { handleClickReturnStep, handleClickNextStep } = Actions

  const { FormRequestGlobal } = Forms
  const { formState, onInputChange, onSelectSearchChange } = FormRequestGlobal

  return (
    <>
      <Typography sx={{ mt: 3, fontWeight: 'bold' }} variant='subtitle2'>
        Resumen de Deuda
      </Typography>
      <div className="border-bottom border-dark"></div>

      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2, mt: 2 }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="saldo_financiar">Monto del Credito (Q)</label>
            <TextField
              id='saldo_financiar'
              name='saldo_financiar'
              value={formState.saldo_financiar}
              onChange={onInputChange}
              size='small'
              placeholder='Monto a Financiar'
              type='text'
              variant='filled'
              InputProps={{
                readOnly: true
              }}
              required
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
        </Grid>
      </Grid>

      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="suma_total_pagar">Deuda Restante del Credito (Q)</label>
            <TextField
              id='suma_total_pagar'
              name='suma_total_pagar'
              value={formState.suma_total_pagar}
              onChange={onInputChange}
              size='small'
              placeholder='Deuda Restante del Credito'
              type='text'
              variant={'filled'}
              InputProps={{ readOnly: true }}
              required
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="suma_dias_atraso_totales">Total dias de atraso</label>
            <TextField
              id='suma_dias_atraso_totales'
              name='suma_dias_atraso_totales'
              value={formState.suma_dias_atraso_totales}
              onChange={onInputChange}
              size='small'
              placeholder='Día de registro'
              type='text'
              variant={'filled'}
              InputProps={{ readOnly: true }}
              required
            />
          </FormControl>
        </Grid>

      </Grid>

      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="total_gastos_admin">Deuda Gastos Administrativos (Q)</label>
            <TextField
              id='total_gastos_admin'
              name='total_gastos_admin'
              value={formState.total_gastos_admin}
              onChange={onInputChange}
              size='small'
              placeholder='Deuda Gastos Juridicos'
              type='text'
              variant={'filled'}
              InputProps={{ readOnly: true }}
              required
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="total_gastos_juridicos">Deuda Gastos Juridicos (Q)</label>
            <TextField
              id='total_gastos_juridicos'
              name='total_gastos_juridicos'
              value={formState.total_gastos_juridicos}
              onChange={onInputChange}
              size='small'
              placeholder='Deuda Gastos Juridicos'
              type='text'
              variant={'filled'}
              InputProps={{ readOnly: true }}
              required
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
        </Grid>
      </Grid>

      <div className="border-bottom border-dark"></div>

      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2, mt: 2 }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="total_deuda_credito">Total Deuda (Q)</label>
            <TextField
              id='total_deuda_credito'
              name='total_deuda_credito'
              value={formState.total_deuda_credito}
              onChange={onInputChange}
              size='small'
              placeholder='Total Deuda'
              type='text'
              variant={'filled'}
              InputProps={{ readOnly: true }}
              required
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
        </Grid>
      </Grid>

      <div className="text-center">
        {stepApplilication !== 0 && (
          <Button
            startIcon={<ArrowLeftCircle />}
            variant="contained"
            type="button"
            className='btn-round'
            color='warning'
            onClick={handleClickReturnStep}
            sx={{ marginTop: 2, marginRight: 1, marginLeft: 1 }}
          >
            Volver
          </Button>
        )}

        <Button
          endIcon={<ArrowRightCircle />}
          variant="contained"
          type="button"
          className='btn-round'
          color='primary'
          sx={{ marginTop: 2, marginRight: 1, marginLeft: 1 }}
          onClick={handleClickNextStep}
        >
          {stepApplilication === 5 ? 'Finalizar' : 'Continuar'}
        </Button>
      </div>
    </>
  )
}
